import { Fragment, useState } from 'react'

import times from 'lodash/times'

import { Skeleton } from '@/components/ui/skeleton'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import ChevronDownIcon from '@/modules/chatting/icons/chevron-down.svg'
import { classNames } from '@/utils/helpers'

export const UserCardSkeleton = () => {
  const [descriptionType, setDescriptionType] = useState('subscription')

  return (
    <div className="shrink-0 space-y-3 rounded-lg bg-secondary-50 p-3 dark:bg-secondary-600">
      <div className="flex max-w-full items-start justify-between gap-3 overflow-hidden">
        <div className="flex items-center gap-3 overflow-hidden">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="space-y-4 overflow-hidden">
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-[200px] rounded" />
            </div>
            <Skeleton className="h-4 w-[160px] rounded" />
          </div>
        </div>
      </div>
      <Skeleton className="h-4 w-[200px] rounded" />
      <Skeleton className="h-4 w-full rounded" />
      <div className="flex gap-3">
        {times(3).map((num) => (
          <Skeleton
            className="h-9 flex-1 rounded"
            key={num}
          />
        ))}
      </div>
      <Tabs
        value={descriptionType}
        onValueChange={setDescriptionType}
        className="mt-6 flex w-full flex-col justify-center"
      >
        <TabsList className="grid w-full grid-cols-2 self-center bg-transparent dark:border-secondary-400 dark:bg-transparent">
          <TabsTrigger
            value="subscription"
            className="overflow-hidden text-ellipsis data-[state=active]:bg-primary-100 data-[state=active]:text-primary-500 data-[state=active]:shadow-none dark:data-[state=active]:bg-primary-900"
          >
            Subscription
          </TabsTrigger>
          <TabsTrigger
            className="data-[state=active]:bg-primary-100 data-[state=active]:text-primary-500 data-[state=active]:shadow-none dark:data-[state=active]:bg-primary-900"
            value="earnings"
          >
            Earnings
          </TabsTrigger>
        </TabsList>
        <TabsContent
          value="subscription"
          className="mt-2"
        >
          <DetailsSkeleton />
        </TabsContent>
        <TabsContent
          value="earnings"
          className="mt-2"
        >
          <DetailsSkeleton />
        </TabsContent>
      </Tabs>
    </div>
  )
}

const DetailsSkeleton = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  const details = times(isExpanded ? 6 : 2)

  return (
    <div className="space-y-2">
      {details.map((num, index) => (
        <Fragment key={num}>
          <div className="flex items-center justify-between gap-3 text-sm">
            <Skeleton className="h-4 w-[100px]" />
            <Skeleton className="h-4 w-[70px]" />
          </div>
          {index < details.length - 1 && (
            <div className="border-b border-border-secondary" />
          )}
        </Fragment>
      ))}
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1 border-b border-border-secondary" />
        <button
          onClick={() => setIsExpanded((prev) => !prev)}
          className="flex items-center gap-1 text-sm leading-[22px]"
        >
          {isExpanded ? 'Collapse' : 'View More'}
          <ChevronDownIcon
            className={classNames('h-3 w-3', { 'rotate-180': isExpanded })}
          />
        </button>
        <div className="flex-1 border-b border-border-secondary" />
      </div>
    </div>
  )
}
